<template>
  <div>
    <div v-if="getAuthenticated">
    <DashboardHeader title="Upcoming Events" >
      <v-layout row wrap class="mt-2">
        <v-flex xs12 md4>
          <vCardContainer :title="'Events'" :class="getClass" bgColor="white" color="#01579B">
            <template #content>
              <vButton @button-clicked="bulkDeleteEvents"
               color="red" :fab="true"
               icon="mdi-delete"
               class="mx-2"
               style="float:right"
               :small="false"
               :xsmall="true">
               </vButton>
         
            
         <v-data-table
         
            :headers="headers"
            :items="calendarOptions.events"
            :items-per-page="10"
            
          >
            <template v-slot:item.id="{ item }">
              <v-icon @click="editEvent(item)" v-if="!isStaff">mdi-eye</v-icon>
              <v-icon @click="editEvent(item)" v-if="isStaff"
                >mdi-pencil</v-icon
              >
              <v-checkbox
                v-if="isStaff"
                class="shrink"
                :value="item.id"
                v-model="selectedDeleteCandidates"
              ></v-checkbox>
            </template>
          </v-data-table>
            </template>
          </vCardContainer>
        </v-flex>
        <v-flex xs12 md8>
          <vCardContainer :title="'Events Calendar'" :class="getClass" bgColor="#FFF" color="#01579B">
            <template v-slot:content>
            <FullCalendar :options="calendarOptions" class="mx-4" />
            </template>
          </vCardContainer>
        </v-flex>
      </v-layout>
    </DashboardHeader>
    </div>
    <div v-else class="mt-16">
    <WebsiteHeader ></WebsiteHeader>
    
    <v-layout row wrap>
        <v-flex xs12 md4 class="mr-2 ml-4">
          <VirtualScrollCase class="mt-8" :itemHeigth="'800'" :items="[1]" :scrollHeigth="'800'" :title="'Events'">
            <template #header>
          <v-btn
            color="red"
            dark
            class="mx-4"
            x-small
            rounded
            v-if="isStaff"
            @click="bulkDeleteEvents()"
            >Bulk Delete</v-btn
          >
            </template>
            <template #content>
         <v-data-table
            :headers="headers"
            :items="calendarOptions.events"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.id="{ item }">
              <v-icon @click="editEvent(item)" v-if="!isStaff">mdi-eye</v-icon>
              <v-icon @click="editEvent(item)" v-if="isStaff"
                >mdi-pencil</v-icon
              >
              <v-checkbox
                v-if="isStaff"
                class="shrink"
                :value="item.id"
                v-model="selectedDeleteCandidates"
              ></v-checkbox>
            </template>
          </v-data-table>
            </template>
          </VirtualScrollCase>
        </v-flex>
        <v-flex xs12 md7>
          <VirtualScrollCase class="mt-8" :itemHeigth="'800'" :items="[1]" :scrollHeigth="'800'" :title="'Calendar'">
            <template v-slot:content>
            <FullCalendar :options="calendarOptions" />
            </template>
          </VirtualScrollCase>
        </v-flex>
      </v-layout>
    <WebsiteFooter></WebsiteFooter>
    </div>
    <GlobalDialogSlot
        :title="title"
        :dialog="dialog"
        @close-dialog="closeDialog"
      >
        <v-card>
          <div class="px-4">
            <v-text-field
              label="Title"
              :rules="rules"
              hide-details="auto"
              v-model="title"
              :readonly="!isStaff "
            ></v-text-field>
            <v-row class="mt-3">
              <v-col cols="4">
                <v-text-field
                  :readonly="!isStaff"
                  label="Start Date"
                  :rules="rules"
                  hide-details="auto"
                  v-model="startDate"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :readonly="!isStaff"
                  label="End Date"
                  :rules="rules"
                  hide-details="auto"
                  v-model="endDate"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  :readonly="!isStaff"
                  label="Privacy"
                  :rules="rules"
                  hide-details="auto"
                  :items="[
                  {text:'Private',value:'Yes'}
                  ,{text:'Public',value:'No'}]"
                  v-model="privacy"
                ></v-select>
              </v-col>
            </v-row>

            <v-textarea
              :readonly="!isStaff"
              class="mt-2"
              rows="3"
              name="input-7-1"
              label="Event Description"
              v-model="description"
              hint="Details of the event goes in here"
            ></v-textarea>
          </div>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :color="getThemeColor"
              outlined
              @click="saveEvent()"
              rounded
              v-if="isStaff"
              class="mb-10"
              >Save Event</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </GlobalDialogSlot>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue"
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue"
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import VirtualScrollCase from "@/components/myLibrary/VirtualScrollCase.vue"
import vCardContainer from '@/components/Legos/vCardContainer.vue';
import vButton from '@/components/Legos/vButton.vue';

export default {
  components: { 
    DashboardHeader,
    WebsiteHeader,
    WebsiteFooter,
   FullCalendar, 
   GlobalDialogSlot,
   vCardContainer,
   vButton,
   VirtualScrollCase },
  computed: {
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getClass(){
       return this.$store.getters.getClass;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getPostBody() {
      return this.$store.getters.getPostBody;
    },
    isParentOrStudent() {
      return this.$store.getters.isParentOrStudent;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  mounted() {
    this.$store.commit("setLoader", true);
    let status = 'No'
    if(this.getAuthenticated){
      status = 'Yes'
      this.headers.unshift({text:'Private',value:'private'})
    }
    axios
      .postData("/get-all-events", {
        emis:this.getUserSchool.emis,status})
      .then((events) => {
        events.forEach((event, i) => {
          event.color = this.colors[Math.floor(Math.random() * Math.floor(5))];
        });
        this.calendarOptions.events = events;
        this.$store.commit("setLoader", false);
      });
  },
  data() {
    return {
      colors: [
        "#311B92",
        "#E65100",
        "#1B5E20",
        "#B71C1C",
        "#827717",
        "#FFEB3B",
        "#F57F17",
        "#000000",
        "#616161",
      ],
      rules: [(value) => !!value || "Required."],
      selectedDeleteCandidates: [],
      dialog: false,
      eventId: 0,
      startDate: null,
      endDate: null,
      title: null,
      description: null,
      privacy:null,
      headers: [
        {
          text: "Starts",
          align: "start",
          value: "start",
        },
        { text: "Title", value: "title" },
        { text: "Action", value: "id" },
      ],
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        events: [],
        selectable: true,
        buttonText: { today: "Today" },
        select: this.getSelectedDateRange,
        editable: true,
        eventClick: this.handleEventClick,
        eventResize: this.handleEventResize,
        eventDrop: this.handleEventResize,
      },
    };
  },
  methods: {
    handleEventClick(eventObject) {
      const eventId = eventObject.event._def.publicId;
      const event = this.calendarOptions.events.filter((event) => {
        return event.id == eventId;
      });
      this.editEvent(event[0]);
    },
    handleEventResize(eventObject) {
      this.eventId = eventObject.event._def.publicId;
      const start = eventObject.event._instance.range.start;
      const end = eventObject.event._instance.range.end;
      this.startDate = start.toISOString().substr(0, 10);
      this.endDate = end.toISOString().substr(0, 10);
      let event = this.calendarOptions.events.filter((event) => {
        return event.id == this.eventId;
      });
      event = event[0];
      this.title = event.title;
      this.description = event.description;
      this.saveEvent();
    },

    setTitle() {
      if (this.title == null) {
        this.title = "Upcoming Event";
      }
    },
    getSelectedDateRange(eventObject) {
      this.startDate = eventObject.startStr;
      this.endDate = eventObject.endStr;
      this.setTitle();
      this.dialog = true;
    },
    
    saveEvent() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-event",
          {
            eventId: this.eventId,
            title: this.title,
            description: this.description,
            startDate: this.startDate,
            endDate: this.endDate,
            privacy: this.privacy,
          },
          this.getAccessToken
        )
        .then((events) => {
          events.forEach((event, i) => {
            event.color =
              this.colors[Math.floor(Math.random() * Math.floor(5))];
          });
          this.calendarOptions.events = events;
          this.dialog = false;
          this.$store.commit("setLoader", false);
        });
    },
  editEvent(eventItem) {
      this.title = eventItem.title;
      this.startDate = eventItem.start;
      this.endDate = eventItem.end;
      this.description = eventItem.description;
      this.eventId = eventItem.id;
      if(eventItem.private == 'Yes'){
        this.privacy = 'Yes'
      }else{
        this.privacy = 'No'
      }
      this.dialog = true;
    },
    bulkDeleteEvents() {
      if (this.selectedDeleteCandidates.length > 0) {
        if (confirm("Are you sure you want to Delete Selected Events?")) {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/delete-selected-events",
              { eventsIds: this.selectedDeleteCandidates },
              this.getAccessToken
            )
            .then((events) => {
              events.forEach((event, i) => {
                event.color =
                  this.colors[Math.floor(Math.random() * Math.floor(5))];
              });
              this.calendarOptions.events = events;
              this.$store.commit("setLoader", false);
            });
        }
      } else {
        event.preventDefault();
        alert("Ÿou Must At Least Select One Event To Bulk Delete");
      }
    },
    closeDialog() {
      this.title = null;
      this.startDate = null;
      this.endDate = null;
      this.description = null;
      this.eventId = null;
      this.dialog = false;
    },
  },
};
</script>

<style></style>
